
import HeroButton from '@/components/HeroButton'
import ProductPrescriptionOptionSelector from '@/components/ProductPrescriptionOptionSelector'
import StockLevel from '@/components/StockLevel'
import QuantitySelector from '@/components/QuantitySelector'
import ProductGuesstimation from '@/components/ProductGuesstimation'
import Message from '@/components/Message'

import TickIcon from '@/static/svg/prescription/tick-icon.svg'

export default {
  components: {
    HeroButton,
    ProductPrescriptionOptionSelector,
    StockLevel,
    ProductGuesstimation,
    QuantitySelector,
    Message,
    TickIcon,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    selectedOptions: {
      type: Object,
      default: () => ({ leftEye: {}, rightEye: {} }),
    },
    errors: {
      type: Object,
      default: () => ({ leftEye: {}, rightEye: {}, messages: {} }),
    },
    stock: {
      type: Object,
      default: () => ({ leftEye: {}, rightEye: {}, accessory: {} }),
    },
    guesstimation: {
      type: Object,
      default: () => ({}),
    },
    quantity: {
      type: Number,
      default: 1,
    },
    maxQuantity: {
      type: Number,
      default: 36,
    },
    isFilled: {
      type: Boolean,
      default: false,
    },
    isProductDisabled: {
      type: Boolean,
      default: false,
    },
    alternativeProduct: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isColoursOnly: false,
      baseColumns: [
        {
          name: 'leftEye',
          id: 'left',
        },
        {
          name: 'rightEye',
          id: 'right',
        },
      ],
    }
  },
  computed: {
    hasColourOption() {
      return !!this.options.find((option) => option.type === 'colour')
    },
    zeroPowerOption() {
      const powerOptions = this.options.find((option) => option.type === 'power')
      const zeroPowerOption = powerOptions?.items.find((option) => option.label === '0.00')

      return zeroPowerOption
        ? {
            name: powerOptions.name,
            type: 'power',
            value: zeroPowerOption.value,
            label: zeroPowerOption.label,
            scrollTop: 0,
          }
        : null
    },
    canSelectColorsOnly() {
      return this.hasColourOption && this.zeroPowerOption
    },
    hasValidationErrors() {
      const { isSelected: isLeftEyeSelected } = this.selectedOptions.leftEye
      const { isSelected: isRightEyeSelected } = this.selectedOptions.rightEye
      const hasLeftEyeErrors = !!Object.keys(this.errors.leftEye).length
      const hasRightEyeErros = !!Object.keys(this.errors.rightEye).length

      return (isLeftEyeSelected && hasLeftEyeErrors) || (isRightEyeSelected && hasRightEyeErros)
    },
    isLeftEyeSelected: {
      get() {
        return this.selectedOptions.leftEye.isSelected
      },
      set(isChecked) {
        this.$emit('eye-toggled', 'left', isChecked)
      },
    },
    isRightEyeSelected: {
      get() {
        return this.selectedOptions.rightEye.isSelected
      },
      set(isChecked) {
        this.$emit('eye-toggled', 'right', isChecked)
      },
    },
    columns() {
      const columns = [...this.baseColumns]
      columns.forEach((column) => {
        const columnSelectedOptions = this.selectedOptions[column.name]
        const columnErrors = this.errors[column.name]
        column.isSelected = columnSelectedOptions.isSelected
        column.selectedOptions = columnSelectedOptions.options
        column.errors = columnErrors
      })
      return columns
    },
  },
  methods: {
    selectColoursOnly() {
      const option = this.zeroPowerOption

      this.$emit('option-selected', { id: 'left', option })
      this.$emit('option-selected', { id: 'right', option })
      this.isColoursOnly = true
    },
    deselectColoursOnly() {
      const option = { name: this.zeroPowerOption.name }

      this.$emit('option-selected', { id: 'left', option })
      this.$emit('option-selected', { id: 'right', option })

      this.isColoursOnly = false
    },
    onHelpClicked() {
      this.$emit('help-clicked')
    },
    selectEyeOption(event) {
      this.$emit('option-selected', { id: event.id, option: event.option })
    },
    updatedQuantity(quantity) {
      this.$emit('quantity-updated', quantity)
    },
    addToBasket() {
      this.$emit('added-to-basket')
    },
  },
}
